import Api from './api.service';

export default {
  requestPasswordReset: (email) =>
    Api.get(`auth/password-reset-request`, { params: { email } }),
};
